

const services = [
{
title:"Paper Supply",
text:"High-quality paper for commercial, industrial and office applications.",
icon:"📄"
},
{
title:"Packaging Solutions",
text:"Reliable board and packaging materials for every industry.",
icon:"📦"
},
{
title:"Bulk Orders",
text:"Competitive pricing and dependable delivery for large-volume requirements.",
icon:"🚛"
},
{
title:"Custom Sourcing",
text:"Helping customers find specialised paper products for unique applications.",
icon:"🔍"
},
{
title:"Reliable Distribution",
text:"Efficient logistics ensuring products reach you on time.",
icon:"🌍"
},
{
title:"Customer Support",
text:"Dedicated assistance before, during and after every order.",
icon:"🤝"
}
];

export default function ServicesSection() {

return(

<section className="services-section">

<div className="container">

<h2>Our Services</h2>

<p className="section-description">
We provide complete paper solutions tailored to the needs of businesses across multiple industries.
</p>

<div className="services-grid">

{services.map((item,index)=>(

<div className="service-card" key={index}>

<div className="service-icon">
{item.icon}
</div>

<h4>{item.title}</h4>

<p>{item.text}</p>

</div>

))}

</div>

</div>

</section>

);

}